import { render, staticRenderFns } from "./TAdvancedComboButtonBox.vue?vue&type=template&id=6223bc3a&scoped=true&"
import script from "./TAdvancedComboButtonBox.vue?vue&type=script&lang=js&"
export * from "./TAdvancedComboButtonBox.vue?vue&type=script&lang=js&"
import style0 from "./TAdvancedComboButtonBox.vue?vue&type=style&index=0&id=6223bc3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6223bc3a",
  null
  
)

/* custom blocks */
import block0 from "./TAdvancedComboButtonBox.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports